export var UiListItemType = /* @__PURE__ */ ((UiListItemType2) => {
  UiListItemType2["Default"] = "default";
  UiListItemType2["Checkbox"] = "checkbox";
  return UiListItemType2;
})(UiListItemType || {});
export const UiListItemTypeAll = Object.values(UiListItemType);
